import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { useDispatch, useSelector } from 'react-redux';
import QuietTimeListLayout from '../../../alert_actions/quiet_times/QuietTimeListLayout/QuietTimeListLayout';
import QuietTimeFormLayout from '../../../alert_actions/quiet_times/QuietTimeFormLayout/QuietTimeFormLayout';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import { fetchQuietTimes, selectQuietTimesCrudStatus } from '../../../../redux/slices/quietTimesSlice/quietTimesSlice';
import RaaRoute from '../../../common/RaaRoute';

function QuietTimesPage() {
  const dispatch = useDispatch();
  const crudStatus = useSelector(selectQuietTimesCrudStatus);

  useEffect(() => {
    if (crudStatus === CrudStatus.IDLE || crudStatus === CrudStatus.PENDING) {
      dispatch(fetchQuietTimes());
    }
  });

  if (crudStatus === CrudStatus.PENDING) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div><ProgressSpinner progressText="Loading..." /></div>
      </div>
    );
  }

  return (
    <Switch>
      <RaaRoute path="/s/actions/quiet-times" exact>
        <QuietTimeListLayout />
      </RaaRoute>
      <RaaRoute path="/s/actions/quiet-times/new" exact>
        <QuietTimeFormLayout />
      </RaaRoute>
      <Route
        path="/s/actions/quiet-times/edit/:quietTimeId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const quietTimeId = parseInt(actionMatch.params.quietTimeId, 10);
          return <QuietTimeFormLayout quietTimeId={quietTimeId} />;
        }}
      />
      <Route
        path="/s/actions/quiet-times/clone/:quietTimeId"
        exact
      />
    </Switch>
  );
}

export default QuietTimesPage;
